
  import * as kontentAiProviderRuntime$fIELHwwxFd1mjb8aecDhHZFRh0Nu_Y8S6pSzDnPDviI from '/working_dir/site/providers/kontent-ai-image-provider.ts'
import * as ipxStaticRuntime$XgLLbe8lf2WPZgSWUmjBlmuvhMAZFZ_45EWTPrF8_DMhs from '/working_dir/site/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['kontentAiProvider']: { provider: kontentAiProviderRuntime$fIELHwwxFd1mjb8aecDhHZFRh0Nu_Y8S6pSzDnPDviI, defaults: undefined },
  ['ipxStatic']: { provider: ipxStaticRuntime$XgLLbe8lf2WPZgSWUmjBlmuvhMAZFZ_45EWTPrF8_DMhs, defaults: {} }
    }
  }
